/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import type { IResourceName } from 'volta/models/base-model';

import templateOnlyComponent from '@ember/component/template-only';

interface BvCollectionLoaderSignature {
  Args: {
    absolute?: boolean;
    resourceName?: IResourceName;
  };
}

const BvCollectionLoaderComponent = templateOnlyComponent<BvCollectionLoaderSignature>();

export default BvCollectionLoaderComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    BvCollectionLoader: typeof BvCollectionLoaderComponent;
    'bv-collection-loader': typeof BvCollectionLoaderComponent;
  }
}
